import fetchCustom from '@helpers/fetchCustom';

export const RECRUITMENT_PLAN_EDITOR = 'recruitment_plan_editor';

export const fetchPositionRecruitmentPlanEditor = async (jobId) => {
    const params = new URLSearchParams();
    params.append('expand', RECRUITMENT_PLAN_EDITOR);
    return fetchCustom(`/api/jobs/${jobId}/ui?${params.toString()}`, { method: 'GET' });
};